<template>
  <b-modal v-model="modal_usuario.mostrar"
           :title="accionUsuario + ' usuario' + (accionUsuario !== 'Crear' ? (' - ' + selectedUsuario.name) : '')"
           hide-footer
           size="xl"
  >
    <b-tabs>

      <!-- Pestaña general -->
      <b-tab title="General"
             active
      >
        <form @submit.prevent="validarFormularioUsuarios"
              data-vv-scope="usuarios"
        >
          <b-row>
            <b-col lg="3"
                   md="3"
                   sm="12"
            >
              <b-form-group>
                <label for="cedula">Cédula<span style="color: red;"> (*)</span></label>
                <b-form-input type="text"
                              name="cedula"
                              id="cedula"
                              v-model="selectedUsuario.cedula"
                              data-vv-as=" "
                              v-validate="'required|max:30'"
                />
                <span class="text-danger span-error small">{{ errors.first('usuarios.cedula') }}</span>
              </b-form-group>
            </b-col>
            <b-col lg="3"
                   md="3"
                   sm="12"
            >
              <b-form-group>
                <label for="name">Nombre<span style="color: red;"> (*)</span></label>
                <b-form-input type="text"
                              name="name"
                              id="name"
                              v-model="selectedUsuario.name"
                              @keyup="sanitizarNombre"
                              data-vv-as=" "
                              v-validate="'required|max:60'"
                />
                <span class="text-danger span-error small">{{ errors.first('usuarios.name') }}</span>
              </b-form-group>
            </b-col>
            <b-col lg="3"
                   md="3"
                   sm="12"
            >
              <b-form-group>
                <label for="email">Correo<span style="color: red;">(*)</span></label>
                <b-form-input type="email"
                              name="email"
                              id="email"
                              v-model="selectedUsuario.email"
                              data-vv-as=" "
                              v-validate="'required|email'"
                />
                <span class="text-danger span-error small">{{ errors.first('usuarios.email') }}</span>
              </b-form-group>
            </b-col>
            <b-col lg="3"
                   md="3"
                   sm="12"
            >
              <b-form-group>
                <label for="telefono">Telefono</label>
                <b-form-input type="text"
                              v-model="selectedUsuario.telefono"
                              data-vv-as=" "
                              v-validate="'max:30'"
                />
              </b-form-group>
            </b-col>
            <b-col lg="3"
                   md="3"
                   sm="12"
            >
              <b-form-group>
                <label for="rol">Rol <span style="color: red;"> (*)</span></label>
                <el-select name="rol"
                           id="rol"
                           data-vv-as=" "
                           v-validate="'required'"
                           multiple
                           v-model="selectedUsuario.roles_usuario"
                >
                  <el-option v-for="item in rolesSeleccionados"
                             :label="item.rol"
                             :value="item.id"
                             :key="item.id"
                  />
                </el-select>
                <span class="text-danger span-error small">{{ errors.first('usuarios.rol') }}</span>
              </b-form-group>
            </b-col>
              <b-col lg="3"
                     md="3"
                     sm="12"
                     v-if="isProvider"
              >
                  <b-form-group>
                      <label for="slq_provider_id">Proveedor <span style="color: red;"> (*)</span></label>
                      <el-select name="slq_provider_id"
                                 id="slq_provider_id"
                                 data-vv-as=" "
                                 v-validate="'required'"
                                 v-model="selectedUsuario.slq_provider_id"
                      >
                          <el-option v-for="item in providers"
                                     :label="item.name"
                                     :value="item.id"
                                     :key="item.id"
                          />
                      </el-select>
                      <span class="text-danger span-error small">{{ errors.first('usuarios.slq_provider_id') }}</span>
                  </b-form-group>
              </b-col>

            <b-col lg="3"
                   md="3"
                   sm="12"
            >
              <b-row>
                <b-col>
                  <b-form-group label="Multiusuario">
                    <b-form-radio-group id="tipo_multiusuario"
                                        v-model="selectedUsuario.tipo_multiusuario"
                                        data-vv-as=" "
                                        v-validate="'required'"
                                        @change="changeTypeMultiuser"
                                        :options="opciones"
                                        buttons
                                        :button-variant="selectedUsuario.tipo_multiusuario ? 'outline-primary' : 'outline-secondary'"
                                        name="tipo_multiusuario"

                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="selectedUsuario.tipo_multiusuario == 1">
                  <b-form-group id="multiusuario"
                                label="# de accesos"
                  >
                    <b-form-input type="number"
                                  min="1"
                                  v-model="selectedUsuario.multiusuario"
                                  value:edicionUsuario.multiusuario
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col lg="3"
                   md="3"
                   sm="12"
                   v-if="selectedUsuario.tipo_multiusuario == 1 && accionUsuario === 'Actualizar'"
            >
              <b-form-group label="Contraseña">
                <b-input-group id="Contraseña"
                               label="Contraseña"
                >
                  <b-form-input v-model="selectedUsuario.password"
                                name="password-user"
                                data-vv-as=" "
                                v-validate="'passwordValidation'"
                                id="password-user"
                                type="password"
                                autocomplete="new-password"
                  />
                  <b-input-group-append>
                    <b-button @click="mostrarContrasena"><i class="el-icon-view"></i></b-button>
                  </b-input-group-append>
                </b-input-group>
                <span class="text-danger span-error small" v-show=" errors.first('usuarios.password-user')">{{ errors.first('usuarios.password-user') }}</span>
                <span class="text-danger span-error small">{{ errors.first('usuarios.password') }}</span>
              </b-form-group>
            </b-col>

            <b-col lg="3"
                   md="3"
                   sm="12"
            >
              <b-form-group label="¿Recibe reportes?">
                <b-form-radio-group id="recibe_reportes"
                                    v-model="selectedUsuario.recibe_reportes"
                                    data-vv-as=" "
                                    v-validate="'required'"
                                    :options="opciones"
                                    buttons
                                    :button-variant="selectedUsuario.recibe_reportes ? 'outline-primary' : 'outline-secondary'"
                                    name="recibe_reportes"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Usuario activo">
                <b-form-radio-group id="usuario_activo"
                                    name="usuario_activo"
                                    data-vv-as=" "
                                    v-validate="'required'"
                                    v-model="selectedUsuario.activo"
                                    :options="opciones"
                                    buttons
                                    :button-variant="selectedUsuario.activo ? 'outline-primary' : 'outline-secondary'"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Usuario interno">
                <b-form-radio-group id="interno"
                                    name="interno"
                                    data-vv-as=" "
                                    v-validate="'required'"
                                    v-model="selectedUsuario.interno"
                                    :options="opciones"
                                    buttons
                                    :button-variant="selectedUsuario.interno ? 'outline-primary' : 'outline-secondary'"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12"
                   class="text-center"
            >
              <hr>
              <b-button type="button"
                        align-v="center"
                        size="sm"
                        variant="primary"
                        @click="validarFormularioUsuarios"
              >
                <i class="fa fa-save"/> {{ accionUsuario }} Usuario
              </b-button>
            </b-col>
          </b-row>
        </form>
      </b-tab>

      <!-- Pestaña permisos -->
      <b-tab title="Permisos" v-if="accionUsuario === 'Actualizar' && assingPermissions" @click="loadPermissions">
        <permissions type="users"></permissions>
      </b-tab>

      <!-- Pestaña reportes -->
      <b-tab v-if="selectedUsuario.recibe_reportes && accionUsuario !== 'Crear'" title="Configuración reportes FDS" v-on:click="goToContentReport()">

        <b-card class="shadow-sm border-0">
          <b-row>
            <!-- Ubicaciones -->
            <b-col lg="4" md="4" sm="12">
              <b-form-group>
                <label for="bases">Ubicaciones</label>
                <treeselect
                  :value="val"
                  :multiple="true"
                  :options="ubicEmpresa"
                  :normalizer="normalizerLocations"
                  value-consists-of="ALL_WITH_INDETERMINATE"
                  v-model="locations"
                  @input="setLocationsToFdsConfigsReportUser"
                />
              </b-form-group>
            </b-col>
            <!-- Tipo de reporte -->
            <b-col lg="4" md="4" sm="12">
              <b-form-group>
                <label for="">Tipo de reporte (*)</label>
                <el-select
                  v-model="fdsConfigsReportUser.slq_inventory_id"
                  filterable
                  clearable
                  placeholder="Selecciona el tipo de reporte"
                >
                  <el-option
                    v-for="item in inventoryTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Guardar -->
          <div class="d-flex justify-content-start align-items-center mt-2">
            <button
              @click="() => handleStoreChangesConfigsReport()"
              class="btn btn-primary"
              :disabled="!fdsConfigsReportUser.slq_inventory_id"
            >
              Guardar cambios
            </button>
          </div>

        </b-card>

      </b-tab>

      <!-- Pestaña Carga masiva -->
      <b-tab title="Carga masiva"
             v-if="accionUsuario === 'Crear'"
      >
        <form @submit.prevent="validarFormularioArchivo"
              data-vv-scope="masivo"
        >
          <b-row>
            <b-col sm="6"
                   offset="3"
            >
              <b-form-group>
                <label for="usuariosImportacionMasiva">Cargar Excel</label>
                <b-form-file type="file"
                             accept=".csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                             id="usuariosImportacionMasiva"
                             name="usuariosImportacionMasiva"
                             placeholder="Seleccione un archivo"
                             @change="obtenerExcelUsuarios"
                             v-model="usuariosImportacionMasiva"
                             data-vv-delay="1000"
                             data-vv-as=" "
                             v-validate="'required|mimes:.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                />
                <span class="text-danger span-error small">{{ errors.first('masivo.usuariosImportacionMasiva') }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="6"
                   offset="3"
            >
              <b-button variant="success"
                        class="mx-1"
                        type="button"
                        size="sm"
                        @click.prevent="descargarPlantillaUsuarios"
              >
                <i class="fa fa-file-excel-o"></i>
                Descargar plantilla
              </b-button>
              <b-button variant="primary"
                        type="button"
                        class="mx-1 float-right"
                        size="sm"
                        @click.prevent="validarFormularioArchivo"
              >
                <i class="fa fa-upload"/> Importar usuarios
              </b-button>
            </b-col>
          </b-row>
        </form>
      </b-tab>

      <!-- Pestaña de Variables configurables -->
        <b-tab v-if="accionUsuario !== 'Crear'" title="Variables configurables" v-on:click="goToContentConfigVars()">

          <b-card class="shadow-sm border-0">

            <!-- variables configurables -->
            <SelectConfigVars
              ref="selectConfigVarsRef"
              :companyId="selectedEmpresa.id"
              @inputChange="updateChildConfigVarUser"
            />

            <!-- Guardar -->
            <div class="d-flex justify-content-start align-items-center mt-4">
              <button
                @click="() => onHandleStoreConfigsVars()"
                class="btn btn-primary"
              >
                Guardar cambios
              </button>
            </div>

          </b-card>

        </b-tab>

    </b-tabs>
  </b-modal>
</template>

<script>

// importaciones generales
import {mapActions, mapMutations, mapState} from 'vuex';

// permisos
import { getAcls } from '../../../plugins/acl';

// componentes
import permissions from '../../administracion/roles_permissions/permissions.vue';
import Treeselect from "@riophae/vue-treeselect";
import VeeValidate from 'vee-validate';
import SelectConfigVars from '../ConfigurableVariables/selectConfigVars.vue';

// Agregar regla de validación personalizada
VeeValidate.Validator.extend('passwordValidation', {
  getMessage: () => 'La contraseña debe contener al menos una letra minúscula, una letra mayúscula, un número, un carácter especial y tener una longitud mínima de 8 caracteres',
  validate: value => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=~`{}[\]|:;"'<>,.?\\/])\S{8,}$/.test(value),
});

export default {
  components: {
    permissions,
    Treeselect,
    SelectConfigVars
  },
  name: 'UsuarioFormulario',
  data() {
    return {
      buscarPermiso: '',
      modalImportes: false,
      archivo: null,
      usuariosImportacionMasiva: null,
      opciones: [
        {text: 'Si', value: 1},
        {text: 'No', value: 0},
      ],
      val: null,
      inventoryTypes: [],
      locations: [],
      defaultProps: {
        disabled: "disabled",
      }
    };
  },
  mounted() {
    this.validatePermissionsAssignment();
    this.getInventoryTypes();
  },
  computed: {
    ...mapState('empresa', [
      'listadoUsuario',
      'selectedEmpresa',
      'modal_usuario',
      'selectedUsuario',
      'accionUsuario',
      'rolesSeleccionados',
      'importesAgendados',
      'rolusuario',
      'roles',
      'permisos',
      'permisosSeleccionados',
      'licencia',
      'licencia_activa',
      'providers',
      'fdsConfigsReportUser',
      'configVarUser',
      'assingPermissions'
    ]),
    ...mapState("Reporteinventario", [
      "ubicEmpresa",
    ]),
    // Estados del modulo Variables configurables
    ...mapState('configurableVariables', ['model']),
    isProvider(){

      let is_provider = false;

      if (!!this.selectedUsuario && !!this.selectedUsuario.roles_usuario.length){
          this.selectedUsuario.roles_usuario.map(ru => {
              const role = this.rolesSeleccionados.find(r => r.id === ru);
              if(role && role.rol){
                if (role.rol === 'Proveedores'){
                  is_provider = true;
                }
              }
          })
      }

      return is_provider;
    },
    usuariosActivos() {
      return this.listadoUsuario.data.filter(u => u.activo).length;
    }
  },
  methods: {
    async loadPermissions() {
      await this.getUserPermissions(this.selectedUsuario.id);
    },
    cambiarPermisos(id, index) {
      let data = {
        id: id,
        index: index
      }
      this.cambiaPermiso(data);
    },
    ...mapMutations('dashboard', ['load']),
    ...mapMutations('empresa', [
      'establecerAccionUsuario',
      'filtraPermiso',
      'establecerNombreUsuario',
      'setIdEmpresaSelectedUsuario',
      'cambiaPermiso',
      'establecerModalUsuario',
      'setFdsConfigsReportUser',
      'setLocationsToFdsConfigsReportUser',
      'setDefaultDataFdsConfigsReportUser',
      'setConfigVarUser'
    ]),
    ...mapActions("rolesPermissions", [
      'getRolPermissions',
      'getUserPermissions'
    ]),
    ...mapActions('empresa', [
      'getPermisosPorRol',
      'guardaPermisosRol',
      'eliminaPermisosRol',
      'getPermisosFiltro',
      'guardaUsuario',
      'updateUser',
      'descargarPlantillaUsuarios',
      'listarImportesAgendados',
      'importarUsuarios',
      'storeConfigsReport',
      'getFDSConfigsReportByUserId',
      'storeCompanyCountryUser',
      'getCompanyCountryUser',
      'validatePermissionsAssignment'
    ]),
    ...mapActions("Reporteinventario", [
      "listarUbicacionesEmpresa"
    ]),
    ...mapActions("inventoryTypes", [
      "listInventoryType",
    ]),
    // Mutaciones del modulo Variables configurables
    ...mapMutations('configurableVariables', ['setModel']),
    ...mapActions('background_processes', ['generateScheduling']),
    ...mapMutations('background_processes', ['setType']),
    async validarFormularioArchivo() {
      await this.$validator.validateAll('masivo')
        .then(async (validado) => {
          if (validado) {
            await this.importarUsuariosMasivo();
          }
        });
    },
    async validarFormularioUsuarios() {
      await this.$validator.validateAll('usuarios')
        .then(async (validado) => {
          this.setIdEmpresaSelectedUsuario(this.$route.params.id);
          if (validado) {
            if (this.accionUsuario === 'Crear') {
              await this.guardaUsuario();
            } else {
              await this.updateUser();
            }
          }
        });
    },
    async filtrarPermiso(filPermiso) {
      await this.filtraPermiso(filPermiso);
      await this.getPermisosFiltro();
    },
    async importarUsuariosMasivo() {
      let formData = new FormData();

      const acls = getAcls();

      if (acls && acls.uuid){
        formData.append('uuid', acls.uuid);
      }

      formData.append('file', this.archivo);
      formData.append('empresa', this.selectedEmpresa.id);

      this.setType('USUARIOS-CARGA-MASIVA');
      await this.generateScheduling(formData).then(async (response) => {
        this.establecerModalUsuario(false);
      });
    },
    sanitizarNombre() {
      const nombre = this.selectedUsuario.name.replace(/[&\[\]/\\#,|+()$~%'":*?¿¡<>´{}]/g, '');
      this.establecerNombreUsuario(nombre);
    },
    obtenerExcelUsuarios(e) {
      let file = e.target.files[0];
      this.archivo = file;
    },
    mostrarContrasena() {
      var tipo = document.getElementById('password-user');
      if (tipo.type == 'password') {
        tipo.type = 'text';
      } else {
        tipo.type = 'password';
      }
    },
    // Propiedades y metodos para el selector de ubicaciones
    normalizerLocations(node) {
      return {
        children: node.children && node.children.length ? node.children : 0,
      };
    },
    // ver el contenido de las configuraciones de fds reporte
    async goToContentReport() {
      this.setLocationsToFdsConfigsReportUser([]);
      this.setDefaultDataFdsConfigsReportUser();

      await this.getFDSConfigsReportByUserId().then(() => {
        this.locations = this.fdsConfigsReportUser.locations;
        this.setDefaultTypeReportFDS();
      });
    },
    // Actualizar el valor en el padre con el valor del hijo
    updateChildConfigVarUser(value) {
      this.setConfigVarUser(value);
    },
    /**
     * ver el contenido de las variables configuraciones
     * @author Fernando Claros
    */
    goToContentConfigVars() {

      const payload = {
        companyId: this.selectedEmpresa.id,
        userId: this.selectedUsuario.id
      }

      this.getCompanyCountryUser(payload).then(() => {
        this.$refs.selectConfigVarsRef.model = this.configVarUser
      })

    },
    /**
     * Guardar configuraci{on de la varibale configurable
     * @author Fernando Claros
    */
    onHandleStoreConfigsVars() {

      const payload = {
        companyId: this.selectedEmpresa.id,
        userId: this.selectedUsuario.id,
        configVarId: this.configVarUser
      }

      this.storeCompanyCountryUser(payload);

    },
    // Establecer por defecto el tipo de reporte: FDS (esto caso tal no tenga uno definido)
    setDefaultTypeReportFDS() {
      const fdsInventoryType = this.inventoryTypes.find(x => x.code === 'FDS');
      if (!fdsInventoryType || this.fdsConfigsReportUser.slq_inventory_id !== "" || this.fdsConfigsReportUser.sys_user_id !== "")
        return false;

      this.setFdsConfigsReportUser({ ...this.fdsConfigsReportUser, slq_inventory_id: fdsInventoryType.id });
    },
    // Obtener los tipos de reportes de los inventarios
    async getInventoryTypes() {
      await this.listarUbicacionesEmpresa(this.selectedEmpresa.id);

      // Respuesta del servicio
      const response = await this.listInventoryType();

      // Solo los tipos de reportes validos para este modulo.
      this.inventoryTypes = response.filter(types => (types.code === 'COMP' || types.code === 'GENE' || types.code === 'FDS') ? true : false);
    },
    // Guardar los datos de la configuracion de repotes para el usuario.
    async handleStoreChangesConfigsReport() {
      const configData = {
        company_id: this.selectedEmpresa.id,
        locations: this.fdsConfigsReportUser.locations,
        inventory: this.fdsConfigsReportUser.slq_inventory_id,
        user_id: this.selectedUsuario.id,
        is_active: 1
      };

      await this.storeConfigsReport(configData);
    },

    changeTypeMultiuser() {
      this.selectedUsuario.password = this.selectedUsuario.tipo_multiusuario === 0 ? "" : this.selectedUsuario.password;
    },

  },
};
</script>

<style>
.permisos {
  display: block;
  height: 350px;
  overflow-x: auto;
}
.background-tree{
  background-color: #f9f9f9;
  padding: 10px 3px;
}
</style>
